<template>
    <div>
        <user-table @user-selected="goToDetails($event.id)"/>
        <v-row class="mt-2 mr-0">
            <v-spacer/>
            <v-btn @click="invitation.showForm=!invitation.showForm" color="primary">Inviter</v-btn>
            <v-dialog max-width="400" v-model="invitation.showForm">
                <v-card :loading="invitation.submitting">
                    <v-card-title>Invitation</v-card-title>
                    <v-card-text>
                        <user-invitation @sent="goToDetails($event.id)" v-model="invitation.submitting"/>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
	import UserTable from "../../components/UserTable";
	import UserInvitation from "../../components/UserInvitation";

	export default {
		name: "UserManagementView",
		components: {UserTable, UserInvitation},
		data() {
			return {
				invitation: {
				    showForm: false,
                    submitting: false
                }
			}
		},
        methods: {
			goToDetails(userId) {
				this.$router.push({name:'userDetail', params: {userId:userId}})
            }
        }
	}
</script>

<style scoped>

</style>
